module.exports = __webpack_public_path__ + "img/Solution4.3321c997.png";